/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=309d5c39"
const script = {}

const cssModules = {}
import style0 from "./App.vue?vue&type=style&index=0&id=309d5c39&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__